<paragraph-wysiwyg [value]="paragraph.fieldWysiwygModContent.value"></paragraph-wysiwyg>